import {clearErrors} from './FormValidation'

export default function (showToast = true, flattenErrors = true) {
  return {
    data() {
      return {
        handler$error: '',
      }
    },
    computed: {
      handler$hasError() {
        return this.handler$error.length > 0
      }
    },
    watch: {
      handler$error(message) {
        if(!showToast || message.length === 0) {
          return
        }

        this.$bvToast.toast(message, {
          title: 'Hiba',
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true
        })
      }
    },
    methods: {
      clearErrors: () => clearErrors(),
      handleErrors(err) {
        var errors = {}
        var message = ''

        if(typeof err.response === 'undefined' || typeof err.response.data === 'undefined' || typeof err.response.data.message === 'undefined') {
          this.$nextTick(() => {
            message = 'Hiba történt a művelet közben!'
          })
        } else {
          message = err.response.data.message

          if (typeof err.response.data.errors !== 'undefined') {
            if(typeof this.parseErrors === 'function') {
              this.parseErrors(err.response.data.errors)
            } else if(flattenErrors) {
              message += ' ' + this.flattenErrors(err.response.data.errors).join(' ')
            }

            errors = err.response.data.errors
          }
        }

        this.handleError(message)
        return errors
      },
      handleError(msg) {
        this.handler$error = ''

        // delay setting error and message to ensure changes for watchers
        this.$nextTick(() => {
          this.handler$error = msg
        })
      },
      flattenErrors: function(errors) {
        if(!errors) {
          return []
        }

        return _.map(errors, (value) => {
          return _.isArray(value) ? value.join(' ') : value
        })
      },
    }
  }
}